import { render, staticRenderFns } from "./create_activity_step2.vue?vue&type=template&id=0901839a&scoped=true"
import script from "./create_activity_step2.vue?vue&type=script&lang=js"
export * from "./create_activity_step2.vue?vue&type=script&lang=js"
import style0 from "./create_activity_step2.vue?vue&type=style&index=0&id=0901839a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0901839a",
  null
  
)

export default component.exports